import { render, staticRenderFns } from "./notifications_snack.vue?vue&type=template&id=4b02e572"
import script from "./notifications_snack.vue?vue&type=script&lang=js"
export * from "./notifications_snack.vue?vue&type=script&lang=js"
import style0 from "./notifications_snack.vue?vue&type=style&index=0&id=4b02e572&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports